(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxListMenuNew($rootScope) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: "&callback"
      },
      templateUrl: 'app/directives/listMenu_2/listMenu_2.template.html',
      link: function(scope) {

        scope.me = $rootScope.currentUser;

        scope.$watch(function (){
          return scope.meta
        }, function () {
          init()
        })

        function init () {
          angular.element('.list-menu-2').css({opacity: 0});
          var position = document.getElementById(scope.meta.parentId).getBoundingClientRect();
          var offsetLeft = null;
          var offsetTop = null;

          if (angular.element('.context-content-container')[0]) {
            offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;
            offsetTop  =  angular.element('.context-content-container')[0].offsetTop;
          } else {
            if (angular.element('.context-content-container-alt')[0]) {
              offsetLeft  =  angular.element('.context-content-container-alt')[0].offsetLeft;
              offsetTop  =  angular.element('.context-content-container-alt')[0].offsetTop;
            }
          }

          setTimeout(function () {
            var left = (offsetLeft ? position.x - offsetLeft + 15 : position.x + 15) + (scope.meta.offset?.horizontal ?? 0);
            var top = (offsetTop ? position.y - offsetTop - 15 : position.y - 15) + (scope.meta.offset?.vertical ?? 0);
            angular.element('.list-menu-2').css({ left: left + 'px', top: top + 'px', opacity: 1 });
          });

          scrollListener();
        }

        function scrollListener () {
          angular.element('#'+ scope.meta.scrollContainerId).on('scroll', function (event) {
            scope.closeListMenu();
          })
        }

        function undbindScroll () {
          angular.element('#'+ scope.meta.scrollContainerId).off('scroll')
        }

        scope.selectMenuItem = function (event, action) {
          event.stopPropagation();
          scope.callback({context: scope.context, action: action});
          undbindScroll();
        }

        scope.closeListMenu = function () {
          angular.element('.list-menu-2').css({opacity: 0});
          scope.callback({context: null, action: null});
          undbindScroll();
        }

        scope.canUserDeleteSnmpConfiguration = function (snmpConfiguration) {
          return !snmpConfiguration.info.tenantDefault &&
            (scope.me.permissions.TENANT_ADMIN || snmpConfiguration.info.networkIds.length) &&
            !snmpConfiguration.info._embedded?.printers?.printerCount;
        };

      }
    };
  }

  pxListMenuNew.$inject = ['$rootScope'];

  angular
    .module('printix-admin')
    .directive('pxListMenuNew', pxListMenuNew);

})();
